import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TwoFactor from "./TwoFactor";
import axios from "axios";
import {initTranslations} from "./i18n";

const rootNativeElement = document.getElementById('two-factor-app');

if (rootNativeElement) {
    const root = ReactDOM.createRoot(rootNativeElement);
    const completeUrl = rootNativeElement.getAttribute('data-complete-url')
        || rootNativeElement.getAttribute('data-skip-url')
        || 'http://localhost/users/login' as string;
    const csrfToken = rootNativeElement.getAttribute('data-csrf-token') || '';
    const apiUrl = rootNativeElement.getAttribute('data-api-url') || 'http://localhost/api/v2' as string;
    const verificationId = rootNativeElement.getAttribute('data-verification-id') as string;
    const userEmail = rootNativeElement.getAttribute('data-user-email') || 'no@em.ail' as string;

    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = apiUrl;

    initTranslations('authentication', apiUrl).finally(() => {
        root.render(
            <TwoFactor userEmail={userEmail} completeUrl={completeUrl} csrfToken={csrfToken} verification={verificationId} />
        );
    });
}

